module.exports = __webpack_public_path__ + "integration-ru-logo.png?ab2b5af248de86b13f41c3c82f434d7f";